(function(){
    'use strict';
    angular.module('Services').service('NonManifestedShipmentsChartService', NonManifestedShipmentsChartService);

    NonManifestedShipmentsChartService.$inject = [
        'Shipments',
        '$rootScope',
        '$filter'
    ];

    function NonManifestedShipmentsChartService(
        Shipments,
        $rootScope,
        $filter
    ) {
        return function(servicesColors){
            const userCurrency = $rootScope.GlobalProfile.office.currency;
            let chartData = {
                config: {
                    mainHeader: 'NON MANIFESTED SHIPMENTS',
                    subHeader: 'Daily View',
                    height: '27.9em',
                    legendDivId: 'nonManifestedChartLegend',
                    viewPath: '/manifests',
                    searchParams: {
                        tab: 'non-manifested'
                    }
                },
                data: ''
            };
            init();
            this.chartData = chartData;
            function init() {
                getChartData();
            }

            function getChartData() {
                let currentDate = new Date();
                let year = currentDate.getFullYear();
                let month = currentDate.getMonth();
                const startDate = new Date(year, month, 1);
                const endDate = new Date(year, month + 1, 0);
                let shipmentDatesFilter = {
                    startDate: $filter('date')(startDate, 'yyyy-MM-dd'),
                    endDate: $filter('date')(endDate, 'yyyy-MM-dd')
                };
                const dateDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

                let provider = [];
                let graphs = [];
                for (let i = 0; i < dateDiff; i++) {
                    provider.push({
                        date: new Date(year, month, i)
                    });
                }
                Shipments.getNonManifestedStatistics(shipmentDatesFilter, function (data) {
                    data.content.forEach(function (data) {
                        const carrierProfile = angular.getObjVal(data, 'serviceProfile.carrierProfile');
                        if (!carrierProfile) {
                            return;
                        }

                        data.date = new Date(data.year, data.month - 1, data.day);
                        let dateFoundIndex = provider.findIndex(val => angular.equals(val.date, data.date));
                        if (dateFoundIndex === -1) {
                            let tmpObj = {};
                            tmpObj['date'] = data.date;
                            tmpObj[carrierProfile.name || ''] = data.amount;
                            provider.push(tmpObj);
                        } else {
                            const currentCount = provider[dateFoundIndex][carrierProfile.name] || 0;
                            provider[dateFoundIndex][carrierProfile.name || ''] = currentCount + data.amount;
                        }
                        if (graphs.findIndex(val => angular.equals(val.valueField, carrierProfile.name)) === -1) {
                            graphs.push({
                                fillColorsField: servicesColors.pop(),
                                lineColor: servicesColors.pop(),
                                valueField: carrierProfile.name,
                                balloonText: getBalloonText(carrierProfile),
                                fillAlphas: 1,
                                title: carrierProfile.name,
                                carrierProfile: carrierProfile,
                                lineThickness: 1,
                                type: "column",
                                showHandOnHover: true
                            });
                        }

                    });
                    provider.sort((a, b) => new Date(b.date) - new Date(a.date)).reverse();
                    chartData.data = configChart(provider, graphs);
                });
            }
            function configChart(data, graphsData) {
                return {
                    "type": "serial",
                    "dataProvider": data,
                    "autoDisplay": true,
                    "addClassNames": true,
                    "valueAxes": [{
                        stackType: "regular",
                        parseDates: true,
                        dashLength: 4,
                        minorGridEnabled: false,
                        fontSize: 13,
                        color: '#666666',
                        gridAlpha: 0.1,
                        axisColor: '#999999',
                        labelFunction: formatLabel
                    }],
                    "graphs": graphsData,
                    "categoryAxis": {
                        parseDates: true,
                        minPeriod: "DD",
                        dashLength: 4,
                        minorGridEnabled: false,
                        fontSize: 13,
                        color: '#666666',
                        gridAlpha: 0.1,
                        axisColor: '#999999'
                    },
                    categoryField: "date",
                    dataDateFormat: "MM YYYY",
                    balloonDateFormat: 'DD MMM, YYYY',
                    balloon: {
                        fixedPosition: true
                    },
                    chartCursor: {
                        cursorAlpha: 0,
                        oneBalloonOnly: true
                    },
                    marginTop: 10,
                    listeners: [{
                        "event": "clickGraphItem",
                        "method": function (graphItem) {
                            let selectedDate = $filter('date')(graphItem.item.dataContext.date, 'yyyy-MM-dd');
                            let carrierProfile = graphItem.graph.carrierProfile;
                            let chartFilter = {
                                createdDate: [selectedDate, selectedDate],
                                carrierProfile: carrierProfile,
                                carrierProfileId: carrierProfile.id
                            };
                            localStorage.setItem('shipmentsFilter', angular.toJson(chartFilter));
                            window.location.href = '/manifests?tab=non-manifested';
                        }
                    }],
                    "legend": {
                        "enabled": true,
                        "divId": chartData.config.legendDivId,
                        "position": "bottom",
                        "useGraphSettings": false,
                        "equalWidths": true,
                        "spacing": 3,
                        "autoMargins": true,
                        "marginLeft": 20,
                        "marginTop": 0,
                        "markerSize": 13,
                        "fontSize": 10,
                        "labelText": '[[title]]',
                        "valueText": ""
                    },
                    "export": {
                        "enabled": true
                    }
                };
            }

            function getBalloonText(carrierProfile) {
                return "<span style='font-size: 1.5em; line-height: 1.8em; display: block; text-align: left;'>[[category]]</span><br/>" +
                "<div style='font-size: 1.2em; line-height: 1.5em; text-align: left;'>" +
                "<div><b>Carrier Profile: </b> " + (carrierProfile.name || '') + "</div>" +
                "<div><b>Amount: </b> [[value]] "+ userCurrency + "</div>" +
                "</div><br/>" +
                "<span style='color: #444'>Select day to view transactions</span>";
            }

            function formatLabel(value, valueString) {
                // let's say we dont' want minus sign next to negative numbers
                if (value < 0) {
                    valueString = valueString.substr(1);
                }

                // and we also want a letter C to be added next to all labels (you can do it with unit, but anyway)
                valueString = $filter('bbaCurrency')(valueString , userCurrency);
                return valueString;
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/charts/NonManifestedShipmentsChartService.js